'use client';
import React from 'react';
import WorkAndInsightsHero from '@/components/sections/portfolio/WorkAndInsightsHero';
import WorkAndInsightsGallery from '@/components/sections/portfolio/WorkAndInsightsGallery';
import CaseStudiesSection from '@/components/sections/portfolio/CaseStudiesSection';
import AboutImageMosaic from '@/components/sections/about/AboutImageMosaic';
import CTASection from '@/components/sections/CTASection';
import Breadcrumbs from '@/components/common/Breadcrumbs';

const PortfolioContent = () => {
  return (
    <main className="w-full min-h-screen bg-white">
      <Breadcrumbs 
        items={[
          { name: "Portfolio", url: "/portfolio" }
        ]} 
      />
      <WorkAndInsightsHero />
      <WorkAndInsightsGallery />
      <CaseStudiesSection />
      <AboutImageMosaic />
      <CTASection
        heading={<span>Ready to see how we can bring<br className="hidden sm:block" />your packaging vision to life?</span>}
        description=""
        primaryLabel="Start your Project"
        primaryHref="/quote"
        secondaryLabel="Get In Touch"
        secondaryHref="/contact"
      />
    </main>
  );
};

export default PortfolioContent;
